import { ReactComponent as CaretIcon } from 'src/assets/tailwind/dropdown.svg';
import { Button } from 'src/components/ui/button';
import type { DropdownOption } from 'src/components/ui/dropdown';
import Dropdown from 'src/components/ui/dropdown';
import CustomIconText from 'src/content/Settings/Profile/CustomIconText';
import type { Language } from 'src/content/Settings/Profile/languages';
import { languages } from 'src/content/Settings/Profile/languages';

import { useLanguage } from './useLanguage';

const renderOption = (option: DropdownOption & Language) => (
  <div className="flex gap-1">
    <div className="flex items-center justify-center">
      <CustomIconText text="" customIconSrc={option?.flag} />
    </div>
    <div>
      <div className="font-medium leading-5 text-text-primary">
        {option?.name}
      </div>
    </div>
  </div>
);

export const LanguageDropdown = () => {
  const { language, changeLanguage } = useLanguage();
  const currentLanguage = language ?? languages[0];

  return (
    <Dropdown
      items={languages.map((lang) => ({
        ...lang,
        onClick: () => changeLanguage(lang.code)
      }))}
      trigger={
        <Button
          type="button"
          size="medium"
          category="default"
          hierarchy="secondary"
          className="tw:gap-1"
        >
          <CustomIconText
            customIconSrc={currentLanguage.flag}
            text=""
            customIconHeight={20}
            customIconWidth={20}
          />
          <span className="tw:font-medium tw:leading-5 tw:text-text-primary">
            {currentLanguage.name}
          </span>
          <CaretIcon className="tw:h-m tw:w-m tw:shrink-0" />
        </Button>
      }
      renderItem={renderOption}
    />
  );
};
